{
  "title": "如何申報利益迴避",
  "description": "當您與某件作品的參賽者有可能影響評分公正性的關係時，自行申報利益迴避。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該筆作品仍會留在您的指派清單中，但會加上「已申報迴避」徽章且無法再進入評分頁；伺服器端的送分／存檔與檔案存取 API 也會同步拒絕。",
  "roleNote": "評審",
  "prerequisites": ["已登入評審帳號", "已在指派清單中看到該件作品"],
  "pathLabel": "評審工作區 → 指派清單",
  "steps": [
    {
      "title": "1. 判斷是否構成利益衝突",
      "description": "只要您與某件作品的參賽者有可能影響評分公正性的關係（例如指導過該隊伍、有親屬或雇用關係），就必須申報；是否構成衝突由您本人依實際關係判斷，系統不會自動偵測。"
    },
    {
      "title": "2. 點選「申報利益衝突」",
      "description": "在指派清單中該筆作品旁點選「申報利益衝突」，填寫理由後送出。"
    },
    {
      "title": "3. 確認申報成功",
      "description": "申報成功後該筆作品卡片仍會留在指派清單中，但會加上紅色「已申報迴避」徽章，「申報利益衝突」按鈕消失，原本可進入評分頁的連結改為顯示「您已無法評分此作品。」的提示文字。"
    }
  ],
  "afterward": [
    "該筆作品卡片仍會出現在您的指派清單中，並非被移除或隱藏，而是以「已申報迴避」徽章標示",
    "無法再開啟該作品的評分頁存檔或送出分數，伺服器端每次存檔／送出都會即時檢查並拒絕（`409 CONFLICT_OF_INTEREST`）",
    "也無法再下載該作品的繳交檔案，伺服器端每次檔案存取皆會即時檢查並拒絕",
    "若您先前已鎖定送出的分數在申報後才被記錄利益衝突，該筆分數會在主辦方計算成績時被自動追溯排除，不計入平均"
  ],
  "nextSteps": "若需要撤銷已申報的利益迴避，請聯絡該場競賽的主辦方協助處理。",
  "faq": [
    {
      "q": "申報利益迴避後，該件作品會從清單中消失嗎？",
      "a": "不會。作品卡片仍會留在您的指派清單中，只是會加上「已申報迴避」徽章、無法再進入評分頁；這是刻意設計，讓您與主辦方都能清楚看到「這筆指派存在但已迴避」，而不是讓紀錄無聲消失。"
    },
    {
      "q": "只有我自己能申報利益迴避嗎？",
      "a": "不一定。除了您本人自行申報外，具評審管理權限的主辦方／工作人員也可以在後台直接為您標記某件作品的利益衝突，不需要您本人操作；兩種來源效果相同，皆會在您的指派清單上顯示相同的徽章與限制。"
    },
    {
      "q": "申報後可以自己撤銷嗎？",
      "a": "目前沒有自助撤銷的操作介面；一旦申報成立，該筆迴避紀錄會持續阻擋您評分與下載檔案，如需撤銷請聯絡主辦方協助處理。"
    },
    {
      "q": "利益衝突判定會顯示在案件卡片上嗎？",
      "a": "會，以「已申報迴避」徽章顯示在卡片上；但利益衝突本身不是把案件狀態改成某種特殊值，而是獨立記錄的一筆迴避關係，畫面上的徽章只是依這筆紀錄即時顯示的結果。"
    }
  ]
}
